// extracted by mini-css-extract-plugin
export default {"form":"ExperimentForm_form__fW2Fg","controlsContainer":"ExperimentForm_controlsContainer__PusxZ","field":"ExperimentForm_field__awvd4"};